module.exports = __webpack_public_path__ + "img/process-6.84d838f3.jpg";